import { Button, Flex, Text, Icon, HStack, Circle } from '@chakra-ui/react';

import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import { BiDotsHorizontalRounded } from 'react-icons/bi';

function Pagination({
  totalItems,
  currentPage,
  perPage,
  pageCount,
  gotoPage,
  previousPage,
  nextPage,
  maxVisible = 5,
}) {
  const canPreviousPage = currentPage > 1;
  const canNextPage = currentPage < pageCount;
  const visiblePages = Math.min(maxVisible, pageCount);
  const visiblePagesStart = Math.max(
    1,
    currentPage - Math.floor(visiblePages / 2),
  );
  const visiblePagesEnd = Math.min(
    pageCount,
    visiblePagesStart + visiblePages - 1,
  );
  const visiblePagesArray = Array.from(
    { length: visiblePagesEnd - visiblePagesStart + 1 },
    (v, k) => k + visiblePagesStart,
  );

  // RENTANG yang benar, bukan "berapa yang muat dalam satu halaman".
  //
  // Bentuk lama `totalItems < perPage ? totalItems : perPage` menyebut perPage
  // begitu totalnya lebih besar, TERLEPAS dari halaman mana yang dibuka: 60 item
  // @25/halaman membuat halaman 3 berbunyi "Menampilkan 25 dari 60 hasil"
  // padahal cuma 10 baris tampil. Diukur 2026-09-05 lewat render langsung
  // komponen ini. Itu salah secara faktual, bukan sekadar beda kata.
  //
  // `akhir` dihitung dulu lalu `awal` diikat kepadanya, supaya halaman di luar
  // rentang tidak memproduksi "Menampilkan 101–60".
  const akhir = Math.min(currentPage * perPage, totalItems);
  const awal =
    totalItems === 0 ? 0 : Math.min((currentPage - 1) * perPage + 1, akhir);
  const showing =
    totalItems === 0
      ? 'Tidak ada hasil'
      : `Menampilkan ${awal}–${akhir} dari ${totalItems} hasil`;

  return (
    <Flex
      direction={{ base: 'column', md: 'row' }}
      gap={2}
      justify="space-between"
      align="center"
      my={5}
      px={3}
    >
      <Text fontSize="sm" lineHeight={5}>
        {showing}
      </Text>
      <HStack gap="1px">
        <Button
          size="xs"
          aria-label="Sebelumnya"
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
        >
          <Icon as={MdChevronLeft} />
        </Button>
        {currentPage >= maxVisible && pageCount > maxVisible && (
          <Circle>
            <BiDotsHorizontalRounded />
          </Circle>
        )}
        {visiblePagesArray.map((num) => (
          <Button
            key={num}
            size="xs"
            onClick={() => gotoPage(num)}
            isActive={currentPage === num}
            _active={{ bg: 'teal.500', color: 'white', border: 'none' }}
            backgroundColor="white"
            borderColor="gray.200"
            borderWidth="1px"
          >
            {num}
          </Button>
        ))}
        {currentPage < maxVisible && pageCount > maxVisible && (
          <Circle>
            <BiDotsHorizontalRounded />
          </Circle>
        )}
        <Button
          size="xs"
          aria-label="Berikutnya"
          onClick={() => nextPage()}
          disabled={!canNextPage}
        >
          <Icon as={MdChevronRight} />
        </Button>
      </HStack>
    </Flex>
  );
}

export default Pagination;
